(function ($) {

    APP = {
      common: {
        init: function () {

            $('.js-btn-burger').on('click', function() {

                $('body').toggleClass('-open');
                $('html').toggleClass('-open');

            });

          //Compartilhamento
          $('.share-list').on('click', 'a', function(e){

            window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');

            return false;
          });


          //Upload de arquivos em ajax
          $('.js-file-reader').each(function(i){
              var $context = $(this),
                  $fileInput = $context.find('.js-file');

              $fileInput.on('change', function(evt){
                  var f = evt.target.files[0];
                  if (!f) return false;

                  var r = new FileReader();

                  r.onloadend = function(e) {

                      var filename = f.name,
                          filetype = f.type,
                          filesize = f.size,
                          data     = {
                              "filename": filename,
                              "filetype": filetype,
                              "filesize": filesize
                          };

                      data.file_base64 = e.target.result.split(/,/)[1];

                      $context.find('.js-attachment').val(data.file_base64);
                      $context.find('.js-filename').val(data.filename);
                  };

                  r.readAsDataURL(f);
              });

          });

          //Validação Formulários
          $.addAjaxResponse('form_contato', function(json) {
            $(this).find('button').text('Enviar');

            $('.modal.in').modal('hide');

            if(json.status == 1) {
              $('#modalFeedbackSuccess').modal('show');

              $(this).trigger('reset');
              $('.modal.in form').trigger('reset');
            } else {
              $('#modalFeedbackError').modal('show');
            }
          });

          $.addAjaxResponse('form_news', function(json){
            $(this).find('button').removeClass('-sending');

            if(json.status == 1) {
              $('#modalFeedbackSuccessNewslletter').modal('show');
              $(this).trigger('reset');
            }
          });

          $.addAjaxResponse('form_orcamento', function(json) {
             $(this).find('button').text('Enviar');

            if(json.status == 1) {
              $(this).trigger('reset');
              $('.menu-budget').hide();
              $('.budget-list').html('');
              $('#modalFeedbackSuccessOrcamento').modal('show');
              $('.form-register-wrapper').addClass('hidden');
            } else {
              //Aqui também
              alert(json.mensagem);
            }
          });


          $('form').formProc({
            onStart: function(form) {
              $(form).find('.-error').removeClass('-error');
            },
            onError: function(input, form) {
              $(input).closest('.field-group').addClass('-error');
            },
            onEnd: function(form,valid) {
              if(valid) {
                if ( $(this).find('.news-submit').length > 0 ) {
                    $(this).find('.news-submit').addClass('-sending');
                } else {
                    $(form).find('button').text('Enviando..');
                }
              }
            },
            stopOnError: false
          });

          //  BUDGET BOX
          $('.js-budget-open').on('click', function(event) {
              event.preventDefault();
              $('.menu-budget-wrapper').addClass('-opened');
          });

          $('.js-budget-close').on('click', function(event) {
              event.preventDefault();
              $('.menu-budget-wrapper').removeClass('-opened');
          });

          $('.js-register-open').on('click', function(event) {
              event.preventDefault();
              $('.form-register-wrapper').removeClass('hidden');
          });

          //Interações de orçamento

          //Campos de quantidade
          $(document).on('blur', '.budget-card input', function(){
            var v = $(this).val(),
                i = $(this).closest('.budget-card').data('id'),
                r = $(this).closest('.budget-card').data('ref');

            var formFields = {
              action: 'orcamento',
              subaction: 'update',
              id: i,
              ref: r,
              qnt: v
            };

            $.post(siteConfig.ajaxUrl, formFields, function(json){
              if(json.status == 1) {
                if(json.html) {
                  $('.menu-budget').show();
                  $('.budget-list').html(json.html);
                }
                if(json.hide) {
                  $('.menu-budget').hide();
                }
              }
            });
          });

          //Botão Orçar das peças
          $('#btn-orcamento-add').on('click', function(e){
            e.preventDefault();

            var i = $(this).data('id'),
                $chk = $('.references-wrapper').find('input:checked'),
                v = [];

            if($chk.length > 0) {
              $chk.each(function(i){
                v.push($(this).val());
              });

              var formFields = {
                action: 'orcamento',
                subaction: 'add',
                id: i,
                ref: v,
                qnt: 1
              };

              $.post(siteConfig.ajaxUrl, formFields, function(json){
                if(json.status == 1) {
                  if(json.hide) {
                    $('.menu-budget').hide();
                  } else {
                    if(json.html) {
                      $('.menu-budget').show();
                      $('.budget-list').html(json.html);
                    }
                    $('.js-budget-open').trigger('click');
                  }
                }
              });
            } else {
              $('#modalFeedback').modal('show');
            }
          });

          //Botão excluir
          $(document).on('click', '.budget-card .js-delete', function(e){
            e.preventDefault();

             var i = $(this).closest('.budget-card').data('id'),
                r = $(this).closest('.budget-card').data('ref');

            var formFields = {
              action: 'orcamento',
              subaction: 'update',
              id: i,
              ref: r,
              qnt: 0
            };

            $.post(siteConfig.ajaxUrl, formFields, function(json){
              if(json.status == 1) {
                if(json.hide) {
                  $('.menu-budget').hide();
                } else {
                  if(json.html) {
                    $('.menu-budget').show();
                    $('.budget-list').html(json.html);
                  }
                  $('.js-budget-open').trigger('click');
                }
              }
            });

            $(this).closest('.budget-card').hide();
          });


        }
      },
      home: {
        init: function () {
            $("img.lazy").lazyload({
              effect : "fadeIn"
            });

            $(window).on('scroll', function(event) {
                event.preventDefault();

                console.log( $(this).scrollTop() );

                if( $(this).scrollTop() > 25 ) {
                    $('.previous-collection').fadeOut('fast');
                }
            });

        },
        homeSlider: function () {

            $('.home-slider').slick({
                arrows: false,
                dots: true,
                fade: true,
                speed: 800,
                autoplay: true,
                autoplaySpeed: 5000,
                responsive: [{
                    breakpoint: 768,
                    settings: {
                      dots: false
                    }
                  }]
            });
        }
      },
      collection: {
        init: function() {
          $("img.lazy").lazyload({
            effect : "fadeIn"
          });
        },
        details: function () {
            $('.js-hero-thumbs').slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: false,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 5
                        },
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 3
                        }
                    }
                ]
            });

            $('.js-hero-patterns').slick({
                slidesToShow: 6,
                slidesToScroll: 1,
                infinite: false,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 7
                        },
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 3
                        }
                    }
                ]
            });

            $('#main-image').elevateZoom({
              borderColour: '#dd86ba',
              zoomWindowOffetx: 40
            });

            $('.thumbs-wrapper, .patterns-wrapper ').on('click', 'a.link', function(){
              var ez =   $('#main-image').data('elevateZoom');

              var imgb = $(this).data('image-base'),
                imgz = $(this).data('image-zoom');

                ez.swaptheimage(imgb, imgz);

                return false;
            });
        }
      },
      where_to_find: {

        init: function () {

            $('.js-indication').on('click', function(event) {
                event.preventDefault();
                $('#modalStoreIndication').modal('show');
            });

            $('.js-register').on('click', function(event) {
                event.preventDefault();
                $('#modalStoreRecruiter').modal('show');
            });

            $('#state').on('change', function(){
              var v = $(this).val(),
                  url = $(this).data('url'),
                  act = $(this).data('action'),
                  non = $(this).data('nonce');

              $('#city').find('option:gt(0)').remove();

              if(v) {
                $.post(url,{ id: v, action: act, nonce: non }, function(json){
                  if(json.status == 1 && json.cidades.length > 0) {
                    var opts = '';
                    for (var i = 0 ; i < json.cidades.length; i++) {
                      opts += '<option value="' + json.cidades[i].id + '">' + json.cidades[i].name + '</option>';
                    }

                    $('#city').append(opts);
                  }
                });
              }
            });

            $('#city').on('change', function(){
              var v = $(this).val(),
                  url = $(this).data('url'),
                  act = $(this).data('action'),
                  non = $(this).data('nonce');

              if(v) {
                $.post(url,{ id: v, action: act, nonce: non }, function(json){
                  if(json.status == 1 && json.html) {
                    $('#store-list').html(json.html);

                    var positions = [];
                    $('#store-list').find('.store-card').each(function(i){
                      var lat = $(this).data('lat'),
                          lng = $(this).data('lng');

                      if(lat && lng) {
                        positions.push({ lat:lat, lng:lng });
                      }

                      window.setMapMarkers(positions);

                    });

                  }
                });
              }
            });

        },

        store_indication: function () {
            $('#filestyle').on('change', function(){
                var fileName = $(this)[0].files[0].name;
                $('.filestyle-wrapper > .field-control').val(fileName);
            });

            $('#formTarget').on('load', function(){
              var json = JSON.parse($("#formTarget").contents().find('body').text());

              if(json.status == 1) {
                $('#modalStoreRecruiter form').find('button').text('Enviar');
                $('.modal.in form').trigger('reset');
                $('.modal.in').modal('hide');
                $('#modalFeedbackSuccess').modal('show');

              } else {
                $('#modalFeedbackError').modal('show');
              }

            });
        }
      },
      blog: {
        init: function(){
            var is_ajax_running = false;

            $('#btn-ajax-blog').on('click', function(e){
                e.preventDefault();

                if(!is_ajax_running) {
                    is_ajax_running = true;

                    var url = $(this).data('url'),
                        page = parseInt($(this).data('page')),
                        maxpages = parseInt($(this).data('maxpages')),
                        data = {
                            action: $(this).data('action'),
                            busca: $(this).data('busca'),
                            cat: $(this).data('cat'),
                            page: ++page
                        };

                    $.post(url,data,function(html) {
                        is_ajax_running = false;

                        $('.blog-pagi').before(html);
                    });

                    $(this).data('page', page);

                    if(page >= maxpages) {
                        $(this).hide();
                    }
                }
            });
        }
      }
    };

    UTIL = {
      exec: function (controller, action) {
        var namespace = APP;
        action = (action === undefined) ? "init" : action;

        if (controller !== "" && namespace[controller] && typeof namespace[controller][action] == "function") {
          namespace[controller][action]();
        }
      },

      init: function () {
        var controller = $('main').data('controller');
        var action = $('main').data('action');

        UTIL.exec("common");
        UTIL.exec(controller);
        UTIL.exec(controller, action);
      }
    };

    $(document).ready(UTIL.init);

})(jQuery);
